import { render, staticRenderFns } from "./LanguagesMenu.vue?vue&type=template&id=87d4e550"
import script from "./LanguagesMenu.vue?vue&type=script&lang=js"
export * from "./LanguagesMenu.vue?vue&type=script&lang=js"
import style0 from "./LanguagesMenu.vue?vue&type=style&index=0&id=87d4e550&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports